package com.kinoshazam.model

import com.kinoshazam.config.getPlatformConfig
import kotlinx.serialization.Serializable

@Serializable
data class AppUpdate(
    val link: String = "",
    val hash: String = "",
    val fileSizeBytes: Long = 0,
    val buildNumber: Long = -1,
    val versionName: String? = null,
    val releaseNote: String? = null,
    val forceUpdate: Boolean = false,
) {

    val isNeedUpdate: Boolean
        get() {
            return buildNumber > getPlatformConfig().buildNumber
        }
}

@Serializable
data class Step(
    val title: String,
    val description: String,
)
